
export default class Plugin {

    constructor(_name = '', _type = ''){
        this.name = _name;
        this.type = _type;
    }

}


// WEBPACK FOOTER //
// ./src/plugins/Plugin.js